import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(universal)/error.tsx");
